export default __webpack_public_path__ + "static/media/plus-icon.91c68bfe.svg";